import './Dropdown.css'

import React, { useState, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

function App(props) {
  let [isOpen, setIsOpen] = useState(false)
  
  return (
    <Navbar isDropDownOpen={setIsOpen}>
      <NavItem count={props.count}isOpen={isOpen} icon={<span class="material-symbols-outlined" style={{color:' #484a4d', marginInlineStart:'5rem'}}
      isDropDownOpen={setIsOpen}>settings</span>}>
        <DropdownMenu 
          {...props}
        isDropDownOpen={setIsOpen}>
        </DropdownMenu>
      </NavItem>
    </Navbar>
  );
}

function Navbar(props) {
  return (
    <nav className="dashboard-navbar">
      <ul className="dashboardnavbar-nav">{props.children}</ul>
    </nav>
  );
}

function NavItem(props) {
  // let [isOpen, setIsOpen] = useState(false)
  // const [open, setOpen] = useState(false);
  // let isDropDownOpen = (data) => {
  //   setIsOpen(data)
  // }
  // props.icon.isDropDownOpen

  return (
    <li className="nav-item">
      <a   style={{color:'#ffff'}} onClick={() => props.children.props.isDropDownOpen(!props.isOpen)}>{props.icon}
        {/* { props.count > 0 && props.icon} */}
      </a>
      { props.isOpen && props.children}
    </li>
  );
}

function DropdownMenu(props) {


  const [activeMenu, setActiveMenu] = useState('settings');
  const [menuHeight, setMenuHeight] = useState(null);

  // let [getProductionCharts, setGetProductionCharts] = useState(null)
  // let [getDispatchCharts, setGetDispatchCharts] = useState(null)


  const[selectedTab, setSeletctedTab] = useState(null)
  const dropdowncardRef = useRef(null);


  // useEffect(() => {
  //   setMenuHeight(dropdowncardRef.current?.firstChild.offsetHeight)
  // }, [])


  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdowncardRef.current && !dropdowncardRef.current.contains(event.target)) {
        props.isDropDownOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  },[dropdowncardRef])



  function calcHeight(el) {
    const height = el.offsetHeight;
    setMenuHeight(height);
  }

  function DropdownItem(props) {
    console.log("props:",props)
    const [testText, setTestText] = useState("")
    console.log("event:",props.children)
    
    // useEffect(() => {
    //   if(props.title == "Production"){
    //     props && props.setSelectedCardTitle((prevState) => ({
    //       ...prevState,
    //       production: true
    //   }))
    //   }else if (props.title == "Dispatch"){
    //     props && props.setSelectedCardTitle((prevState) => ({
    //       ...prevState,
    //       dispatch: true
    //   }))
    //   }
    // },[])

    return (
      <a className="menu-item" onClick={(e) => {
        console.log("@isDropDownOpen:",e.target.textContent)
        // props.children.isDropDownOpen(false)
        // setTestText(e.target.textContent.split(/(?=[A-Z])/)[1].trim())
        if(e.target.textContent !== undefined && e.currentTarget.textContent.indexOf(' ') > 0){
          console.log("@event1",e.target.textContent)
          if (props.title == "Production") {
            props && props.setGetProductionCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props && props.setallProductionCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props.isDropDownOpen(false)
          }
          else if (props.title == "Dispatch") {
            props && props.setGetDispatchCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props && props.setallDispatchCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props.isDropDownOpen(false)
          }
          else if (props.title == 'Inward') {
            props && props.setGetInwardCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props && props.setallgetInwardCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props.isDropDownOpen(false)
          }
          else if (props.title == 'Inventory') {
            props && props.setGetInventoryCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props && props.setallgetInventoryCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props.isDropDownOpen(false)
          }
          // console.log("propstarget:",e.target.textContent,props.title) 
          // setGetCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)}
        }
       setActiveMenu('settings')
      }}>
        <span className="icon-button" style={{color:'#ffff'}}>{props.leftIcon}</span>
        {props.children}
        <span className="icon-right" style={{color:'black'}}>{props.rightIcon}</span>
      </a>
    );
  }


  return (
    <div className="dropdowncard" style={{ height: menuHeight }} ref={dropdowncardRef}>

      <CSSTransition
        in={activeMenu === 'settings'}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}>
        <div className="menu">
          {console.log("props1:",props)}
          {/* <DropdownItem
           setallgetInwardCharts={props.setallgetInwardCharts}
           setallDispatchCharts={props.setallDispatchCharts}
           setallProductionCharts={props.setallProductionCharts}
           setallgetInventoryCharts={props.setallgetInventoryCharts}
           setGetProductionCharts={props.setGetProductionCharts} setGetInventoryCharts={props.setGetInventoryCharts} setGetDispatchCharts={props.setGetDispatchCharts} setGetInwardCharts={props.setGetInwardCharts}  goToMenu="main" leftIcon={<span class="material-symbols-outlined"> arrow_back </span>} setSelectedCardTitle={props.setSelectedCardTitle} >Back</DropdownItem> */}
          <DropdownItem
           setallgetInwardCharts={props.setallgetInwardCharts}
           setallDispatchCharts={props.setallDispatchCharts}
           setallProductionCharts={props.setallProductionCharts}
           setallgetInventoryCharts={props.setallgetInventoryCharts}
           setGetProductionCharts={props.setGetProductionCharts} setGetInventoryCharts={props.setGetInventoryCharts} setGetDispatchCharts={props.setGetDispatchCharts} setGetInwardCharts={props.setGetInwardCharts}  title={props.title}   leftIcon={<span class="material-symbols-outlined">bar_chart</span>} setSelectedCardTitle={props.setSelectedCardTitle}
           isDropDownOpen={props.isDropDownOpen}
           >Bar Chart</DropdownItem>
          <DropdownItem
           setallgetInwardCharts={props.setallgetInwardCharts}
           setallDispatchCharts={props.setallDispatchCharts}
           setallProductionCharts={props.setallProductionCharts}
           setallgetInventoryCharts={props.setallgetInventoryCharts}
           setGetProductionCharts={props.setGetProductionCharts} setGetInventoryCharts={props.setGetInventoryCharts} setGetDispatchCharts={props.setGetDispatchCharts} setGetInwardCharts={props.setGetInwardCharts}  title={props.title}  leftIcon={<span class="material-symbols-outlined">pie_chart</span>} setSelectedCardTitle={props.setSelectedCardTitle}
           isDropDownOpen={props.isDropDownOpen}
           >Pie Chart</DropdownItem>
          <DropdownItem
           setallgetInwardCharts={props.setallgetInwardCharts}
           setallDispatchCharts={props.setallDispatchCharts}
           setallProductionCharts={props.setallProductionCharts}
           setallgetInventoryCharts={props.setallgetInventoryCharts}
           setGetProductionCharts={props.setGetProductionCharts} setGetInventoryCharts={props.setGetInventoryCharts} setGetDispatchCharts={props.setGetDispatchCharts} setGetInwardCharts={props.setGetInwardCharts}  title={props.title}  leftIcon={<span class="material-symbols-outlined">donut_small</span>} setSelectedCardTitle={props.setSelectedCardTitle}
           isDropDownOpen={props.isDropDownOpen}
           >Doughnut Chart</DropdownItem>
          {/* <DropdownItem
           setallgetInwardCharts={props.setallgetInwardCharts}
           setallDispatchCharts={props.setallDispatchCharts}
           setallProductionCharts={props.setallProductionCharts}
           setGetProductionCharts={props.setGetProductionCharts} setGetDispatchCharts={props.setGetDispatchCharts} setGetInwardCharts={props.setGetInwardCharts}  title={props.title} leftIcon={<span class="material-symbols-outlined">stacked_line_chart</span>} setSelectedCardTitle={props.setSelectedCardTitle}
           >Line Chart
           </DropdownItem> */}
          <br></br>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === 'animals'}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}>
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<span class="material-symbols-outlined"> arrow_back </span>}>Back
          </DropdownItem>
          {/* {props.data.map((loc) => {
            return (
                <DropdownItem leftIcon={<span class="material-symbols-outlined">pin_drop</span>}>{loc}</DropdownItem>
            )
            })} */}
          <br></br>
        </div>
      </CSSTransition>
    </div>
  );
}

export default App;